import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map } from 'rxjs';
import { environment } from '../../../environments/environment';
import { SessionService } from '../../Util/Session/session.service';

@Injectable({
  providedIn: 'root'
})
export class CompensatoryOffService {

  constructor(
    private http: HttpClient,
    private session: SessionService,
  ) { 
    environment.API_URL = this.session.GetUserDetails().ApiUrl;
  }

  ESS_CompOffRuleInsertUpdate(Detail: any) {
    return this.http.post<any>(environment.API_URL + `ESS_CompOffRuleInsert/Update`,
      this.session.SetClass(Detail)
    ).pipe(map(response => {
      if(response.Error_Code == '11'){
        this.session.End();
      }else{
        return response;
      }
    }));
  }

  ESS_CompOffRuleLoad(Detail: any) {
    return this.http.post<any>(environment.API_URL + `ESS_CompOffRule/Load`,
      this.session.SetClass(Detail)
    ).pipe(map(response => {
      if(response.Error_Code == '11'){
        this.session.End();
      }else{
        return response;
      }
    }));
  }

  ESS_EmployeeCompOffRaiseUpdate(Detail: any) {
    return this.http.post<any>(environment.API_URL + `ESS_EmployeeCompOffRaise/Update`,
      this.session.SetClass(Detail)
    ).pipe(map(response => {
      if(response.Error_Code == '11'){
        this.session.End();
      }else{
        return response;
      }
    }));
  }

  ESS_EmployeeCompOffRaise_LoadLoad(Detail: any) {
    return this.http.post<any>(environment.API_URL + `ESS_EmployeeCompOffRaise_Load/Load`,
      this.session.SetClass(Detail)
    ).pipe(map(response => {
      if(response.Error_Code == '11'){
        this.session.End();
      }else{
        return response;
      }
    }));
  }

  ESS_EmployeeCompOffConsumeLoad(Detail: any) {
    return this.http.post<any>(environment.API_URL + `ESS_EmployeeCompOffConsume/Load`,
      this.session.SetClass(Detail)
    ).pipe(map(response => {
      if(response.Error_Code == '11'){
        this.session.End();
      }else{
        return response;
      }
    }));
  }

  EmployeeCompOffConsumeSave(Detail: any) {
    return this.http.post<any>(environment.API_URL + `EmployeeCompOffConsume/Save`,
      this.session.SetClass(Detail)
    ).pipe(map(response => {
      if(response.Error_Code == '11'){
        this.session.End();
      }else{
        return response;
      }
    }));
  }
  ESS_EmployeeCompOffWithdrawLoad(Detail: any) {
    return this.http.post<any>(environment.API_URL + `ESS_CompOffWithdrawLoad/Get`,
      this.session.SetClass(Detail)
    ).pipe(map(response => {
      if(response.Error_Code == '11'){
        this.session.End();
      }else{
        return response;
      }
    }));
  }
}
